namespace TabAurous.ECommerce {
    export namespace ECommOrderItemsForInvoiceService {
        export const baseUrl = 'ECommerce/ECommOrderItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/ECommOrderItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ECommOrderItemsForInvoiceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
